import { Play } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconPlay12Line = createIcon(Play, 12, "Line");
export const IconPlay16Line = createIcon(Play, 16, "Line");
export const IconPlay20Line = createIcon(Play, 20, "Line");
export const IconPlay24Line = createIcon(Play, 24, "Line");
export const IconPlay32Line = createIcon(Play, 32, "Line");
export const IconPlay48Line = createIcon(Play, 48, "Line");
export const IconPlay64Line = createIcon(Play, 64, "Line");
